// eslint-disable-next-line import/prefer-default-export
export const mapEventForSelect = (event) => ({
  ...event,
  id: `${event?.id} - ${event?.nombre}`,
  realId: event?.id
});
